module.exports = __webpack_public_path__ + "img/BEST_PRACTICE_color.3c495ecb.svg";